import React, { Component } from 'react';
import { Fragment, useState } from "react";
import { inject, observer } from 'mobx-react';

import { Icon } from 'antd';

import PersonalDataModal from './PersonalDataModal';

import './PersonalData.css';
import {Link} from "react-router-dom";
import K from "../../../services/constants";

import { AirModal } from '../../../commonComponents';

export const StaticDocument = ({ src, label }) => {
  const [visible, setVisible] = useState(false);

  return (
      <Fragment>
        <a onClick={() => setVisible(true)}>{label}</a>
        <AirModal className="EmbeddedDocumentModal" width="90vw" visible={visible} onCancel={() => setVisible(false)} destroyOnClose={true}>
          <iframe title="document" src={src} width="100%" height="540" />
        </AirModal>
      </Fragment>
  );
};

@inject('translationsStore', 'step3RegistrationStore')
@observer
class PersonalData extends Component {
  constructor(props) {
    super(props);

    this.readTimeout = null;

    this.state = {
      checkedAll: false,
      showModal: false
    };
  }

  validate = () => {
    return new Promise(resolve => {
      this.data.getForm().validateFields((error, values) => {
        if (error) resolve({ error });
        else resolve({ values });
      });
    });
  };

  personalDataOnClickHandler = e => {
    this.setState({ showModal: true });
    const { step3RegistrationStore } = this.props;
    this.readTimeout =
      !step3RegistrationStore.formValues.personalData.read &&
      setTimeout(() => {
        step3RegistrationStore.setFormField('personalData.read', true);
      }, 5000);
  };

  onCancelHandler = () => {
    const { step3RegistrationStore } = this.props;
    step3RegistrationStore.setFormField('personalData.read', false);
    this.setState({ showModal: false });
  };

  onOkHandler = () => {
    this.setState({ showModal: false });
  };

  onCloseHandler = () => {
    clearTimeout(this.readTimeout);
  };

  render() {
    const { read } = this.props.step3RegistrationStore.formValues.personalData;

    const {
      translationsStore: { current: t }
    } = this.props;

    return (
      <div>
        <PersonalDataModal
          ref={data => {
            this.data = data;
          }}
          visible={this.state.showModal}
          onCancel={this.onCancelHandler}
          onOk={this.onOkHandler}
          onClose={this.onCloseHandler}
        />

        <div className="reviewPrivacySettings" onClick={this.personalDataOnClickHandler}>
          <Icon type="eye" style={{ fontSize: '24px', color: read ? 'darkcyan' : 'lightgrey' }} />
          <div>{t['registration_3']['lblPrivacyCheck']}</div>
        </div>
        <div className="infoPrivacySettings">
          <StaticDocument src={`${K.POLICY_BASE_URL}informativa-privacy-2022.pdf`} label={t['registration_3']['infoPrivacyCheck']} />
        </div>
      </div>
    );
  }
}

export default PersonalData;



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/Step_3/PersonalData.js